import Container from "../BuildingBlocks/Container/Container";
import Classes from "./Calculator.module.scss";
import PrincipalAmount from "./PrincipalAmount/PrincipalAmount";
import MonthlyDeposit from "./MonthlyDeposit/MonthlyDeposit";
import AnnualIntrestRate from "./AnnualIntrestRate/AnnualIntrestRate";
import InvestmentYears from "./InvestmentYears/InvestmentYears";
import { ContextKey, ContextKeys } from "../../types/context-key";
import CalculateButton from "./CalculateButton/CalculateButton";
import ManagementFeesCheckbox from "./ManagementFeesCheckbox/ManagementFeesCheckbox";
import ManagementFeesInputs from "./ManagementFeesInputs/ManagementFeesInputs";
import Banner from "../Banners/Banner/Banner";
import Banners from "../Banners/Banners";
import useIsCompactView from "../../hooks/useIsCompactView";
import InstallButton from "../InstallButton/InstallButton";
import { observer } from "mobx-react";
import { useStore } from "../../store";

export type InputProps = {
  contextKey: ContextKey;
};

// Feature flag to control banner visibility
const SHOW_BANNERS = false;

const Calculator = () => {
  const isCompactView = useIsCompactView();
  const { context } = useStore();

  const renderCalculator = () => {
    return (
      <Container className={Classes.container}>
        <PrincipalAmount contextKey={ContextKeys.PRINCIPAL} />
        <MonthlyDeposit contextKey={ContextKeys.MONTHLY_DEPOSIT} />
        <AnnualIntrestRate contextKey={ContextKeys.ANNUAL_INTREST_RATE} />
        <InvestmentYears contextKey={ContextKeys.NUMBER_OF_YEARS} />
        <ManagementFeesCheckbox />
        {context.managementFeesEnabled && (
          <ManagementFeesInputs />
        )}
        <CalculateButton />
      </Container>
    );
  };

  const renderDesktopView = () => {
    return (
      <>
        <div className={Classes.desktopWrapper}>
          {SHOW_BANNERS && (
            <Banner
              asset={`Banner1.webp`}
              link={"https://lazyinvestor.co.il/book"}
            />
          )}
          {renderCalculator()}
          {SHOW_BANNERS && (
            <Banner
              asset={`Banner2.webp`}
              link={"https://lazyinvestor.info/Registration"}
            />
          )}
        </div>
        <InstallButton />
      </>
    );
  };

  const renderMobileView = () => {
    return (
      <div className={Classes.mobileWrapper}>
        {renderCalculator()}
        <InstallButton />
        {SHOW_BANNERS && <Banners />}
      </div>
    );
  };

  return isCompactView ? renderMobileView() : renderDesktopView();
};

export default observer(Calculator);